// Helpers de layout-como-datos para los forms genéricos (MOOV-5200, D8).
// Un solo camino de render: sin editLayout/createLayout declarado, se genera
// un layout plano sintético (una fila full-width por campo) que reproduce el
// render actual; con layout declarado, los campos no mencionados se anexan
// al final en orden de declaración.

export function flatFormLayout(fields) {
  return fields.map(field => ({ row: [{ span: 12, key: field.key }] }))
}

function collectLayoutKeys(nodes, keys) {
  for (const node of nodes || []) {
    if (typeof node === 'string') {
      keys.add(node)
    } else if (node.key) {
      keys.add(node.key)
    } else if (node.keys) {
      collectLayoutKeys(node.keys, keys)
    } else if (node.row) {
      collectLayoutKeys(node.row, keys)
    }
  }
}

export function mergeFormLayout(declaredLayout, fields) {
  if (!declaredLayout) {
    return flatFormLayout(fields)
  }
  const mentioned = new Set()
  collectLayoutKeys(declaredLayout, mentioned)
  const rest = fields.filter(field => !mentioned.has(field.key))
  return [...declaredLayout, ...flatFormLayout(rest)]
}
